/* eslint-disable react/display-name */
import React from 'react';

function withTracking (WrappedComponent) {
  return class extends React.Component {
    track(obj) {
      const { data } = obj;
      // eslint-disable-next-line
      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        if (typeof dataLayer !== 'undefined') {
          // eslint-disable-next-line
          dataLayer.push(data);
          if (localStorage.getItem('logTracking')) {
            console.log(data);
          }
        }
      }
    }

    render() {
      return <WrappedComponent track={this.track} {...this.props} />;
    }
  };
}

export default withTracking;
